import { useEffect } from 'react';

const AbsoluteRedirect = ({ href }: { href: string }) => {
  useEffect(() => {
    window.location.href = href;
  }, [href]);

  return null;
};

export default AbsoluteRedirect;
